import {useSubtitle} from '../../../../../../common/helpers/react/hooks/useSubtitle';
import {tAsString} from '../../../../../../common/helpers/react/text/tAsString';
import AssigneesTable from '../../assignees/AssigneesTable';
import AssigneesSearch from '../../assignees/AssigneesSearch';
import {useState} from 'react';
import AddAgentsToolbar from './AddAgentsToolbar';

export default function AddAgentsPresenter() {
    useSubtitle(tAsString('MANAGE_AGENTS'));

    const [checkedRows, setCheckedRows] = useState<string[]>([]);

    return (
        <>
            <h1>{tAsString('MANAGE_AGENTS')}</h1>
            <AssigneesSearch/>
            <AddAgentsToolbar
                checkedRows={checkedRows}
                setCheckedRows={setCheckedRows}
            />
            <AssigneesTable
                checkedRows={checkedRows}
                setCheckedRows={setCheckedRows}
            />
        </>
    );
}